import { useEffect, useMemo, useRef, useState } from 'react'

import { cn } from '@/lib/utils'

const CARD_COUNT = 3
const CYCLE_INTERVALS = [5500, 7000, 6200]

export const AUDIENCE_PORTRAIT_PLACEHOLDERS = [
  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDABsSFBcUERsXFhceHBsgKEIrKCUlKFE6PTBCYFVlZF9VXVtqeJmBanGQc1tdhbWGkJ6jq62rZ4C8ybqmx5moq6T/2wBDARweHigjKE4rK06kbl1upKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKT/wAARCAAbABQDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwC9cXVqkZlcE/Lk7W5qGDUYvPMUsTxnB2kNuzVRPIlV4whIk68gYFLZIWYSSjf5QOD9eKhysy1G6LMsuXOxJCv0ooNyVxtYKPcA0VF0HKxIbZ40Yt5Q47Nn/wDVVeGOaPcqFnQndtxz+NO6SEDoXAI9av3KhGLqMMRgkVTVxp2Iba4uYogksOGH48UVAZXJOXP50UcvmHN5H//Z',
  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDABsSFBcUERsXFhceHBsgKEIrKCUlKFE6PTBCYFVlZF9VXVtqeJmBanGQc1tdhbWGkJ6jq62rZ4C8ybqmx5moq6T/2wBDARweHigjKE4rK06kbl1upKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKT/wAARCAAbABQDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwCe4ungtnkjTc6nABHHXrTbSa8aRluduCuQU7e1VYmnIww3AoVwT1qWzm86AK4KEdjWdy0jRiyAQOQDiis6PUooAYy24g9Qp5oppINSl/pE7bgNrJnaFOCtSSPcG2DYYv0Y4xxWkAN+araqzR27FGIJ681KfQbXUdZvpy26gqmR13rkk0VkRk7etFa2M+ZH/9k=',
  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDABsSFBcUERsXFhceHBsgKEIrKCUlKFE6PTBCYFVlZF9VXVtqeJmBanGQc1tdhbWGkJ6jq62rZ4C8ybqmx5moq6T/2wBDARweHigjKE4rK06kbl1upKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKSkpKT/wAARCAAbABQDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDauRlEHGDxn0rMk2+ewkcmN2yAD0pwu5bpxEpIVckvtp7RGSReT8vJ96zbu7o0S7kBOxiqb9ueME0UsrXKSMEclc8cdKKV0KzFhjMNuWRS0hI3r3UelXEKkBuOevPpVWYA24fkMRyQcVRkkeJV8tiuSOlF7aFWvqWbhPMmZhux04YiioIyQXUMQAxwM0UrX1Fsf//Z',
]

interface AudiencePortraitCardsProps {
  imageUrls: Array<string>
  isPlaceholder: boolean
}

function PortraitCard({
  pool,
  startIndex,
  intervalMs,
  isPlaceholder,
}: {
  pool: Array<string>
  startIndex: number
  intervalMs: number
  isPlaceholder: boolean
}) {
  const stepRef = useRef(0)
  const [slotA, setSlotA] = useState(pool[startIndex % pool.length])
  const [slotB, setSlotB] = useState(pool[(startIndex + CARD_COUNT) % pool.length])
  const [showA, setShowA] = useState(true)
  const [entered, setEntered] = useState(!isPlaceholder)

  useEffect(() => {
    if (!isPlaceholder) {
      const t = setTimeout(() => setEntered(true), 30 + startIndex * 60)
      return () => clearTimeout(t)
    }
  }, [isPlaceholder, startIndex])

  useEffect(() => {
    if (isPlaceholder) return

    const prefersReduced =
      typeof window !== 'undefined' &&
      window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches
    if (prefersReduced) return

    let preloadTimer: ReturnType<typeof setTimeout>
    const timer = setInterval(() => {
      stepRef.current += 1
      const step = stepRef.current

      setShowA((prev) => !prev)

      preloadTimer = setTimeout(() => {
        const nextIdx = (startIndex + (step + 1) * CARD_COUNT) % pool.length
        if (step % 2 === 1) {
          setSlotA(pool[nextIdx])
        } else {
          setSlotB(pool[nextIdx])
        }
      }, 1100)
    }, intervalMs)

    return () => {
      clearInterval(timer)
      clearTimeout(preloadTimer)
    }
  }, [pool, startIndex, intervalMs, isPlaceholder])

  useEffect(() => {
    if (isPlaceholder) return
    setSlotA(pool[startIndex % pool.length])
    setSlotB(pool[(startIndex + CARD_COUNT) % pool.length])
    stepRef.current = 0
    setShowA(true)
  }, [pool, startIndex, isPlaceholder])

  const isCenter = startIndex === 1

  const imgClass = cn(
    'absolute inset-0 h-full w-full object-cover object-top transition-all duration-300 ease-in-out',
    isPlaceholder && 'blur-md scale-110',
  )

  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-2xl bg-muted',
        isCenter
          ? 'z-20 w-[min(9rem,22vh)] sm:w-[min(10.5rem,24vh)] md:w-[min(12rem,26vh)] shadow-xl'
          : 'z-10 w-[min(8rem,19vh)] sm:w-[min(9rem,21vh)] md:w-[min(10rem,23vh)] shadow-md',
        'transition-[opacity,transform] duration-250 ease-out',
        entered ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-3 scale-[0.97]',
      )}
    >
      <div className="relative aspect-[3/4]">
        <img
          src={slotA}
          alt=""
          className={cn(imgClass, showA ? 'opacity-100' : 'opacity-0')}
          decoding="async"
          onError={(e) => {
            ;(e.target as HTMLImageElement).style.visibility = 'hidden'
          }}
        />
        <img
          src={slotB}
          alt=""
          className={cn(imgClass, showA ? 'opacity-0' : 'opacity-100')}
          decoding="async"
          onError={(e) => {
            ;(e.target as HTMLImageElement).style.visibility = 'hidden'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
      </div>
    </div>
  )
}

export function AudiencePortraitCards(props: AudiencePortraitCardsProps) {
  const { imageUrls, isPlaceholder } = props

  const pool = useMemo(
    () => [...imageUrls].sort(() => Math.random() - 0.5),
    [imageUrls],
  )

  return (
    <div className="flex items-center justify-center -space-x-4 sm:-space-x-6 md:-space-x-8 overflow-hidden max-w-full">
      {CYCLE_INTERVALS.map((ms, i) => (
        <PortraitCard key={i} pool={pool} startIndex={i} intervalMs={ms} isPlaceholder={isPlaceholder} />
      ))}
    </div>
  )
}
